import { FC } from "react";
import { G, Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdMessage: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 21 19" fill="none" {...props}>
    <G fill="currentColor" stroke="currentColor" strokeWidth={0.2}>
      <Path d="M1 .9H.9V13.767H5.656l.285 4.34.013.2.152-.132 5.065-4.408H20.1V.9H1Zm5.251 12.139H1.628V1.628h17.744v11.41h-8.487l-.029.026-4.28 3.745-.225-3.676-.006-.094h-.094Z" />
      <Path d="M4.747 5.043h-.1v.728h11.626v-.728H4.747ZM4.747 8.58h-.1v.727h11.626v-.728H4.747Z" />
    </G>
  </Svg>
);

export default PdMessage;
